// extracted by mini-css-extract-plugin
module.exports = {"container":"Pay_container__HdczY","content":"Pay_content__3-ov0"};